import axios from 'Axios';

export default {
  getUserProfile() {
    return axios.get('/profile/demand');
  },
  updateUserProfile(data) {
    return axios.post('/profile/demand', data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  updateNonArupCompanyInfo(data) {
    return axios.post('/profile/demand/company', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getFavoriteTickets(projectId) {
    return axios.get(`/project/${projectId}/ticket/favorite`);
  },
  getSuggestedTickets(data) {
    return axios.post('/ticket/suggested', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getTicket(projectId, ticketId) {
    return axios.get(`/project/${projectId}/ticket/${ticketId}/view`);
  },
  setNewCustomCriteriaToMyDefault(ticketId) {
    return axios.post('/criteria/copy', ticketId, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
  checkCriteriaIfExists(ticketId) {
    return axios.get('criteria/check_criteria?ticketId=' + ticketId);
  },
  deleteAsset(imageId) {
    return axios.delete('asset/' + imageId);
  },
};
